import React, { Component } from 'react';
import { Container, Row, Col } from 'reactstrap';
import HustForm from './HustForm';
import 'moment/locale/vi';

class Hust extends Component {
  render() {
    const id =
      this.props.match && this.props.match.params && this.props.match.params.id
        ? this.props.match.params.id
        : '';

    return (
      <div className="page-login app">
        <>
          <Container className="">
            <Row>
              <Col xs="12" md={10} className="mt-4 text-auto">
                <div className="bg-form-profile">
                  <h3
                    className="text-center"
                    style={{
                      paddingTop: 24,
                      paddingBottom: 24,
                      paddingLeft: 12,
                      paddingRight: 12,
                    }}
                  >
                    Hồ sơ dự thi
                  </h3>
                  <HustForm
                    id={id}
                    returnUrl={this.props.location.returnUrl || null}
                    {...this.props}
                  />
                </div>
              </Col>
            </Row>
          </Container>
        </>
      </div>
    );
  }
}

export default Hust;
